/**
 * 랜딩 섹션의 순서. 배열 인덱스가 곧 트래킹의 `index` 라서, 분석 쪽에서
 * `max(index)` 가 스크롤 도달 깊이가 된다. 순서를 바꾸면 과거 데이터와 의미가
 * 어긋나므로, 섹션을 끼워 넣을 땐 뒤에 붙인다.
 */
export const BOARD_LANDING_SECTIONS = [
  'hero',
  'intro',
  'stats',
  'samples',
  'features',
  'faq',
  'bottom_cta',
] as const;

export type BoardLandingSection = (typeof BOARD_LANDING_SECTIONS)[number];
